import React, { useEffect,  useState } from "react";

import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import {
  FondMonthwiseFan,
  FundMonthWise,
} from "../../../../../Redux/Slice/Fas/Financial Statement/Fund And Flow/FundAndFlow";
import { Loader } from "../../../../../components/Loader/Loader";
import { Download } from "lucide-react";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { useTheme } from "../../../../../Themecontext/Themecontext";
import FASparentMultipalChild from "../../../../../components/Tables/FASparentMultipalChild";

export default function FStatement({ bank, month, accountGroup }) {
  const dispatch = useDispatch();

  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const { FundMonthWisedata } = useSelector((state) => state.FundFlowSlice);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );

  const { theme } = useTheme();
  const isdark = theme;
  const Firm = Cookies.get("Firm");
  const YearId = Cookies.get("FinancialYear");
  const [, setdynamic] = useState(["BnkcasName", "GroupMStName"]);

  useEffect(() => {
    setdynamic(["BnkcasName", "GroupMStName"]);
  }, []);
  useEffect(() => {
    dispatch(FondMonthwiseFan());
    dispatch(
      FundMonthWise({
        Firm,
        Year: YearId,
        selectedIds1: bank.join(","),
        MonthName: month.join(","),
        selectedIds: accountGroup.join(","),
      }),
    );
  }, [dispatch, Firm, YearId, bank, month, accountGroup]);

  const formatIndianRupee = (amount) => {
    const clean = String(amount ?? "0").replace(/,/g, "");
    const num = parseFloat(clean);

    if (!isFinite(num)) return "0.00";

    return num.toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const getCrDetailRows = FundMonthWisedata?.CrDetail?.map((item, index) => ({
    srNumber: index + 1,
    acname: item.acname,
    GroupMStName: item.GroupMStName,
    BnkcasName: item.BnkcasName,
    MonthName: item.MonthName,
    Receipt: item.Receipt,
  }));

  const getCrDetailColumns = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Account Group Name",
      key: "GroupMStName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Count", key: "count", align: "center" },
    // {
    //   label: "Bank Name",
    //   key: "BnkcasName",
    //   align: "left",
    //   colors: isdark === "light" ? "#000" : "#fff",
    // },
    {
      label: "Account Name",
      key: "acname",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    // {
    //   label: "Month",
    //   key: "MonthName",
    //   align: "left",
    //   colors: isdark === "light" ? "#000" : "#fff",
    // },
    { label: "Receipt Amount", key: "Receipt", align: "right", format: true },
  ];

  // Second table data (DrDetail)
  const getDrDetailRows = FundMonthWisedata?.DrDetail?.map((item, index) => ({
    srNumber: index + 1,
    acname: item.acname,
    GroupMStName: item.GroupMStName,
    BnkcasName: item.BnkcasName,
    MonthName: item.MonthName,
    Payment: item.Payment,
  }));

  const getDrDetailColumns = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Account Group Name",
      key: "GroupMStName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Count", key: "count", align: "center" },
    // {
    //   label: "Bank Name",
    //   key: "BnkcasName",
    //   align: "left",
    //   colors: isdark === "light" ? "#000" : "#fff",
    // },
    {
      label: "Account Name",
      key: "acname",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    // {
    //   label: "Month",
    //   key: "MonthName",
    //   align: "left",
    //   colors: isdark === "light" ? "#000" : "#fff",
    // },
    { label: "Payment Amount", key: "Payment", align: "right", format: true },
  ];
  const cardStyle = {
    marginTop: "20px",
    borderRadius: "12px",
    overflow: "hidden",
    boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
  };

  const headerStyle = {
    backgroundColor:
      isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour4,
    color: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour3,
    padding: "14px",
  };

  const formatAmount = (value) => {
    const num = Number(value || 0);
    return isNaN(num) ? "0.00" : num.toFixed(2);
  };
  console.log(JSON.stringify(FundMonthWisedata?.Opening, null, 2));

  const handleDownload = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginX = 14;

    /* ================= TITLE ================= */
    doc.setFontSize(14);
    doc.setFont(undefined, "bold");
    doc.text("Fund Flow Statement", pageWidth / 2, 15, { align: "center" });
    doc.line(marginX, 18, pageWidth - marginX, 18);

    const firmName =
      DataMain?.Firm_Dtl?.[0]?.FirmName ||
      DataMain?.Firm_List?.[0]?.GroupName ||
      "";

    doc.setFontSize(12);
    doc.setFont(undefined, "bold");

    doc.text(String(firmName).trim(), pageWidth / 2, 25, {
      align: "center",
    });
    /* =====================================================
       1️⃣ RECEIPT DETAILS – PAGE 1
    ===================================================== */
    let yPos = 35;

    const receiptCols = [15, 55, 45, 45, 35, 35];
    const receiptWidth = receiptCols.reduce((a, b) => a + b, 0);
    const receiptLeft = (pageWidth - receiptWidth) / 2;

    doc.setFontSize(12);
    doc.setFont(undefined, "bold");
    doc.text("RECEIPT DETAILS", pageWidth / 2, yPos, { align: "center" });
    yPos += 5;

    let sr = 1;
    const receiptRows =
      FundMonthWisedata?.CrDetail?.map((r) => [
        sr++,
        r.GroupMStName || "",
        r.BnkcasName || "",
        r.acname || "",
        r.MonthName || "",
        formatAmount(r.Receipt),
      ]) || [];

    const receiptTotal = FundMonthWisedata?.CrDetail?.reduce(
      (s, r) => s + Number(r.Receipt || 0),
      0,
    );

    receiptRows.push(["", "", "", "", "TOTAL", formatAmount(receiptTotal)]);

    autoTable(doc, {
      startY: yPos,
      margin: { left: receiptLeft },
      head: [
        [
          "Sr",
          "Account Group",
          "Bank",
          "Account Name",
          "Month",
          "Receipt Amount",
        ],
      ],
      body: receiptRows,
      theme: "grid",
      bodyStyles: {
        fontStyle: "bold",
      },
      styles: {
        fontSize: 8,
        textColor: [0, 0, 0],
        fontStyle: "bold",
        lineColor: [210, 210, 210],
        lineWidth: 0.2,
        cellPadding: 2,
        valign: "middle",
        overflow: "linebreak",
      },

      headStyles: {
        fillColor: [220, 220, 220],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        halign: "center",
        valign: "middle",
        fontSize: 9,
      },
      columnStyles: {
        0: { halign: "center", cellWidth: receiptCols[0] },
        1: { cellWidth: receiptCols[1] },
        2: { cellWidth: receiptCols[2] },
        3: { cellWidth: receiptCols[3] },
        4: { cellWidth: receiptCols[4] },
        5: { halign: "right", cellWidth: receiptCols[5] },
      },
      didParseCell(data) {
        if (data.row.raw[4] === "TOTAL") {
          data.cell.styles.fontStyle = "bold";
          data.cell.styles.fillColor = [235, 235, 235];
        }
      },
    });

    /* =====================================================
       2️⃣ PAYMENT DETAILS – PAGE 2
    ===================================================== */
    doc.addPage();
    yPos = 30;

    const paymentCols = [15, 55, 45, 45, 35, 35];
    const paymentWidth = paymentCols.reduce((a, b) => a + b, 0);
    const paymentLeft = (pageWidth - paymentWidth) / 2;

    doc.setFontSize(12);
    doc.setFont(undefined, "bold");
    doc.text("PAYMENT DETAILS", pageWidth / 2, yPos, { align: "center" });
    yPos += 5;

    sr = 1;
    const paymentRows =
      FundMonthWisedata?.DrDetail?.map((r) => [
        sr++,
        r.GroupMStName || "",
        r.BnkcasName || "",
        r.acname || "",
        r.MonthName || "",
        formatAmount(r.Payment),
      ]) || [];

    const paymentTotal = FundMonthWisedata?.DrDetail?.reduce(
      (s, r) => s + Number(r.Payment || 0),
      0,
    );

    paymentRows.push(["", "", "", "", "TOTAL", formatAmount(paymentTotal)]);

    autoTable(doc, {
      startY: yPos,
      margin: { left: paymentLeft },
      head: [
        [
          "Sr",
          "Account Group",
          "Bank",
          "Account Name",
          "Month",
          "Payment Amount",
        ],
      ],
      body: paymentRows,
      theme: "grid",
      styles: { fontSize: 9, cellPadding: 2, fontStyle: "bold" },
      headStyles: {
        fillColor: [220, 220, 220],
        fontStyle: "bold",
        halign: "center",
      },
      columnStyles: {
        0: { halign: "center", cellWidth: paymentCols[0] },
        1: { cellWidth: paymentCols[1] },
        2: { cellWidth: paymentCols[2] },
        3: { cellWidth: paymentCols[3] },
        4: { cellWidth: paymentCols[4] },
        5: { halign: "right", cellWidth: paymentCols[5] },
      },
      didParseCell(data) {
        if (data.row.raw[4] === "TOTAL") {
          data.cell.styles.fontStyle = "bold";
          data.cell.styles.fillColor = [235, 235, 235];
        }
      },
    });

    /* ================= PAGE NUMBER ================= */
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(8);
      doc.text(`Page ${i}`, marginX, pageHeight - 5);
    }

    doc.save("Fund_Flow_Statement.pdf");
  };

  const handleDownload1 = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginX = 14;

    /* ================= TITLE ================= */

    doc.setFontSize(14);
    doc.setFont(undefined, "bold");
    doc.text("Fund Flow Statement", pageWidth / 2, 15, { align: "center" });
    doc.line(marginX, 18, pageWidth - marginX, 18);

    const firmName =
      DataMain?.Firm_Dtl?.[0]?.FirmName ||
      DataMain?.Firm_List?.[0]?.GroupName ||
      "";

    doc.setFontSize(12);
    doc.setFont(undefined, "bold");

    doc.text(String(firmName).trim(), pageWidth / 2, 25, {
      align: "center",
    });
    /* ================= DATA PREPARE ================= */

    const receiptData = FundMonthWisedata?.CrDetail || [];
    const paymentData = FundMonthWisedata?.DrDetail || [];

    const maxRows = Math.max(receiptData.length, paymentData.length);

    let tableRows = [];

    for (let i = 0; i < maxRows; i++) {
      const r = receiptData[i];
      const p = paymentData[i];

      tableRows.push([
        i + 1,
        r?.acname || "",
        r ? formatAmount(r.Receipt) : "",
        p?.acname || "",
        p ? formatAmount(p.Payment) : "",
      ]);
    }

    /* ================= TOTAL CALC ================= */

    const receiptTotal = receiptData.reduce(
      (sum, r) => sum + Number(r.Receipt || 0),
      0,
    );

    const paymentTotal = paymentData.reduce(
      (sum, r) => sum + Number(r.Payment || 0),
      0,
    );

    tableRows.push([
      "",
      "TOTAL",
      formatAmount(receiptTotal),
      "TOTAL",
      formatAmount(paymentTotal),
    ]);

    /* ================= TABLE CENTER CALC ================= */

    const totalTableWidth = 70 + 35 + 70 + 35; // column width sum
    const startX = (pageWidth - totalTableWidth) / 2;

    /* ================= TABLE ================= */

    autoTable(doc, {
      startY: 32,

      margin: { left: startX },
      tableWidth: totalTableWidth,

      head: [
        [
          "Sr No.",
          "Receipt Account",
          "Receipt Amount",
          "Payment Account",
          "Payment Amount",
        ],
      ],

      body: tableRows,

      theme: "grid",
      styles: {
        fontSize: 8,
        textColor: [0, 0, 0],
        fontStyle: "bold",
        lineColor: [210, 210, 210],
        lineWidth: 0.2,
        cellPadding: 2,
        valign: "middle",
        overflow: "linebreak",
      },

      headStyles: {
        fillColor: [220, 220, 220],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        halign: "center",
        valign: "middle",
        fontSize: 9,
      },
      columnStyles: {
        0: { halign: "center", cellWidth: 20 }, // Sr No.
        1: { cellWidth: 65 }, // Receipt Account
        2: { halign: "right", cellWidth: 30 }, // Receipt Amount
        3: { cellWidth: 65 }, // Payment Account
        4: { halign: "right", cellWidth: 30 }, // Payment Amount
      },

      didParseCell(data) {
        if (data.row.raw?.[1] === "TOTAL") {
          data.cell.styles.fontStyle = "bold";
          data.cell.styles.fillColor = [235, 235, 235];
        }
      },
    });

    /* ================= PAGE NUMBER ================= */

    doc.setFontSize(8);
    doc.text("Page 1", marginX, pageHeight - 5);

    /* ================= SAVE ================= */

    doc.save("Fund_Flow_Combined_Table.pdf");
  };

  if (FundMonthWisedata === "no" || FundMonthWisedata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }
  return (
    <div style={{ marginTop: "20px" }}>
      <Row className="g-3">
        <Col lg={12}>
          <Row className="align-items-center mb-3">
            {/* Opening Amount */}
            <Col xl={6} lg={6} md={12}>
              <div
                style={{
                  background:
                    isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour2,
                  border: `1px solid ${
                    isdark === "light"
                      ? iscolour?.Colour3
                      : iscolourDark?.Colour10
                  }`,
                  borderLeft: `6px solid ${
                    isdark === "light"
                      ? iscolour?.Colour6
                      : iscolourDark?.Colour10
                  }`,
                  borderRadius: "12px",
                  padding: "14px 18px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  minHeight: "90px",
                }}
              >
                <h4
                  style={{
                    margin: 0,
                    fontWeight: "600",
                    color:
                      isdark === "light"
                        ? iscolour?.Colour6
                        : iscolourDark?.Colour10,
                  }}
                >
                  {formatIndianRupee(FundMonthWisedata?.Opening?.[0]?.OpAmount)}
                </h4>

                <h6
                  style={{
                    marginTop: "6px",
                    marginBottom: 0,
                    color:
                      isdark === "light"
                        ? iscolour?.Colour12
                        : iscolourDark?.Colour12,
                    fontWeight: "600",
                  }}
                >
                  Opening Amount
                </h6>
              </div>
            </Col>

            {/* Buttons */}
            <Col
              xl={6}
              lg={6}
              md={12}
              className="d-flex justify-content-lg-end justify-content-md-start mt-md-3 mt-3 mt-lg-0"
            >
              <div className="d-flex gap-2 flex-wrap">
                <button
                  onClick={handleDownload}
                  className="common-hover-btn"
                  style={{
                    backgroundColor:
                      isdark === "light"
                        ? iscolour?.Colour4
                        : iscolourDark?.Colour6,
                    color:
                      isdark === "light"
                        ? iscolour?.Colour11
                        : iscolourDark?.Colour12,
                    border: "none",
                    padding: "10px 16px",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    cursor: "pointer",
                    fontWeight: "500",
                    fontSize: "14px",
                    height: "44px",
                  }}
                >
                  <Download size={16} />
                  Format 1
                </button>

                <button
                  onClick={handleDownload1}
                  className="common-hover-btn"
                  style={{
                    backgroundColor:
                      isdark === "light"
                        ? iscolour?.Colour4
                        : iscolourDark?.Colour6,
                    color:
                      isdark === "light"
                        ? iscolour?.Colour11
                        : iscolourDark?.Colour12,
                    border: "none",
                    padding: "10px 16px",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    cursor: "pointer",
                    fontWeight: "500",
                    fontSize: "14px",
                    height: "44px",
                  }}
                >
                  <Download size={16} />
                  Format 2
                </button>
              </div>
            </Col>
          </Row>

          <div style={cardStyle}>
            <div style={headerStyle}>
              <h2
                style={{
                  fontSize: "18px",
                  margin: 0,
                  letterSpacing: "1px",
                  color:
                    isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour11,
                  fontWeight: "600",
                }}
              >
                RECEIPT DETAILS
              </h2>
            </div>

            <FASparentMultipalChild
              data={getCrDetailRows}
              columns={getCrDetailColumns}
              externalTotals={FundMonthWisedata?.CrSummary?.[0] || {}}
            />
          </div>
        </Col>

        {/* RIGHT SIDE */}
        <Col lg={12}>
          <div style={cardStyle}>
            <div style={headerStyle}>
              <h2
                style={{
                  fontSize: "18px",
                  margin: 0,
                  letterSpacing: "1px",
                  color:
                    isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour11,
                  fontWeight: "600",
                }}
              >
                PAYMENT DETAILS
              </h2>
            </div>

            <FASparentMultipalChild
              data={getDrDetailRows}
              columns={getDrDetailColumns}
              externalTotals={FundMonthWisedata?.DrSummary?.[0] || {}}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
}
